// The gold our hand-drawn action icons are stroked with, and the color the row option cell paints every icon in -
// MUI's own icons take currentColor, so without this they render in IconButton's default grey next to our gold
// ones. Note it is 1.59:1 on white: fine while a label sits beside the icon, thin for an icon standing alone
// (WCAG 1.4.11 asks 3:1). Kept on purpose - the brand gold won over the contrast.
export const ICON_ACCENT = '#F2C94C';
